import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconExpandChevronOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g fill="currentColor" fillRule="nonzero"><path d="M22.72 10.113 12 1.67 1.28 10.113a.9.9 0 0 1-1.06 0c-.293-.231-.293-.605 0-.836L12 0l11.78 9.277c.293.23.293.605 0 .836a.9.9 0 0 1-1.06 0M1.28 13.887 12 22.33l10.72-8.443a.9.9 0 0 1 1.06 0c.293.231.293.605 0 .836L12 24 .22 14.723c-.293-.23-.293-.605 0-.836a.9.9 0 0 1 1.06 0" /></g></svg>
);
